<template>
</template>

<script>

import moment from "moment";
import {sleep} from "@/util/sleep";

export default {
  name: 'InfiniteAudio',
  props: ['src'],
  data() {
    return {
      audio: false,
      mutedState: true,
      muteStep: 0.01,
      waitAfterMuteStep: 20,
      lastAudioVolume: 0,
    }
  },

  computed: {

    muted: {
      async set(shouldBeMuted) {

      },

      get() {
        return this.lastAudioVolume === 0;
      }
    }

  },

  methods: {


    playOrPause: function () {
      if (this.audio.paused) {
        this.audio.play();
      } else {
        this.audio.pause();
      }
    },

    play() {
      this.audio.play();
    },

    pause() {
      this.audio.pause();
    },

    async unmute() {
      this.$emit('unmuted');
      return this.play(); // TODO: replace with mute working for iOS devices

      for (let i = 0; i < 1; i += this.muteStep) {
        this.audio.volume = i;
        await sleep(this.waitAfterMuteStep);
      }

      this.audio.volume = 1;

    },

    async mute() {
      this.$emit('muted');
      return this.pause(); // TODO: replace with mute working for iOS devices

      for (let i = 1; i > 0; i -= this.muteStep) {
        this.audio.volume = i;
        await sleep(this.waitAfterMuteStep);
      }


      this.audio.volume = 0;
    },

    onPause: function () {
      this.paused = true;
      this.$emit('pause');

    },

    onPlay: function () {
      this.paused = false;
      this.$emit('play');
    },

    onTimeUpdate: function () {
      this.lastAudioVolume = this.audio.volume;
    }


  },

  created() {
    this.audio = new Audio(this.src);
    this.audio.pause();
    this.audio.loop = true;

    this.audio.ontimeupdate = this.onTimeUpdate;
    this.audio.onplay = this.onPlay;
    this.audio.onpause = this.onPause;
  }
}
</script>

<style>

.control {
  font-size: 40px;
  color: white;
}

</style>
